import Topheader from "./Nav";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import ScrollToTop from "../../utility/ScrollTop";
const Layout = () => {
  return (
    <div>
      <Topheader />
      <div style={{minHeight:"100vh" }}>
        <Outlet />
        <ScrollToTop/>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
